import type { ManualPlanAction } from '@/types/rich-content'

/** Discriminated EN contract for notification actions in the wire body. */
export type NotificationAction =
  | { kind: 'open' | 'complete'; notificationId: string; linkedWorkOrderId: string }
  | { kind: 'detail'; notificationId: string }

/** Presentation is separate from the canonical instruction and action payload. */
export interface ClickedActionWireOptions {
  clickedActionLabel?: string
  intentId?: string
  notificationAction?: NotificationAction
  manualPlanAction?: ManualPlanAction
}
export function clickedActionWireOptions(options?: {
  displayText?: string
  intentId?: string
  notificationAction?: NotificationAction
  manualPlanAction?: ManualPlanAction
}): ClickedActionWireOptions | undefined {
  const { displayText: label, intentId, notificationAction, manualPlanAction } = options ?? {}
  const clickedActionLabel = label && label.length <= 300 ? label : undefined
  const wire: ClickedActionWireOptions = {}
  if (clickedActionLabel) wire.clickedActionLabel = clickedActionLabel
  if (intentId) wire.intentId = intentId
  if (notificationAction) wire.notificationAction = notificationAction
  if (manualPlanAction) wire.manualPlanAction = manualPlanAction
  return Object.keys(wire).length > 0 ? wire : undefined
}

/** Only verified server click metadata can replace user-bubble presentation. */
export function persistedClickLabel(metadata: unknown): string | undefined {
  if (!metadata || typeof metadata !== 'object' || Array.isArray(metadata)) return undefined
  const click = (metadata as Record<string, unknown>).actionClickPresentation
  if (!click || typeof click !== 'object' || Array.isArray(click)) return undefined
  const { source, label, locale } = click as Record<string, unknown>
  return source === 'suggested_action' &&
    typeof label === 'string' &&
    label.trim().length > 0 &&
    label.length <= 300 &&
    /^[^\p{Cc}]*$/u.test(label) &&
    ['pt-BR', 'en-US', 'es-419'].includes(String(locale))
    ? label
    : undefined
}
